import AbstractFotaItemDelegate from "../AbstractFotaItemDelegate.js";
export default class FirmwareApplicationItemDelegate extends AbstractFotaItemDelegate {
  getApi() {
    return this.api.firmwareApplication();
  }
}